import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {repeat} from 'lit/directives/repeat.js'
import {normalizeStyles} from "@webs/components-library/theming";
import {Breadcrumb} from "./breadcrumb";

@customElement('webs-breadcrumbs')
export class Breadcrumbs extends LitElement {

  static styles = [
    normalizeStyles,
    css`

      .m-breadcrumbs {
            font-family: var(--font-family-alternative);
            align-items: center;
            display: flex;
            flex-wrap: wrap;
            list-style: none;
            margin: 0;
            margin-bottom: 1.6rem;
            padding: 0;
      }

      .m-breadcrumbs li,
      .m-breadcrumbs a {
          color: var(--color-action);
          font-size: .7rem;
          font-weight: var(--font-weight-semibold);
          line-height: 1.3;
          text-decoration: none;
      }

      .m-breadcrumbs.variant li,
      .m-breadcrumbs.variant a {
        font-weight: var(--font-weight-strong);
      }

      .m-breadcrumbs.is-white li,
      .m-breadcrumbs.is-white a {
          color: var(--color-white);
      }
      .m-breadcrumbs.is-white li::after {
        background: var(--color-white);
      }
      .m-breadcrumbs li {
        position: relative;
        padding-right: 0.75rem;
        margin-right: .5rem;
      }

      .m-breadcrumbs li::after {
          background: var(--color-action);
          border-radius: 50%;
          content: '';
          flex: 0 0 6px;
          height: 6px;
          right: 0;
          margin-left: .6rem;
          position: absolute;
          top: 5px;
          width: 6px;
      }

      .m-breadcrumbs:last-of-type {
        margin-right: 0;
        padding-right: 0;
      }

      .m-breadcrumbs li:last-of-type::after {
          display: none;
      }


    `
  ];

  @property({type: Array})
  items: Breadcrumb[]

  @property({attribute: 'is-white', type: Boolean})
  isWhite: boolean;

  @property({attribute: 'variant', type: Boolean})
  isVariant: boolean;

  protected render(): unknown {
    let breadcrumbClasses = this.isWhite ? 'is-white': '';
    breadcrumbClasses = this.isVariant ? `${breadcrumbClasses} variant` : breadcrumbClasses;
    return html`
      ${this.items && this.items.length ? html`
        <ul part="container" class="m-breadcrumbs ${breadcrumbClasses}">
          ${repeat(this.items, (item, index) => html`
              <li>
                ${item.href ? html`
                  <a target="${item.openInNewTab ? '_blank' : ''}" rel="${item.rel ? item.rel : ''}"
                     href="${item.href}">${item.title}</a>
                ` : item.title}
              </li>
            `
    )}
        </ul>
      ` : ''}
    `;
  }
}
